import getSymbolFromCurrency from 'currency-symbol-map';
import { Product } from '@/types/Content/Product/Product';
import { Variant } from '@/types/Content/Product/Variant';
import {
  AffiliatedStyledButton,
  AffiliateIcon,
  ButtonsWrapper,
  Price,
} from './PurchaseSection.styles';

interface AffiliateButtonProps
  extends Pick<Product, 'affiliatedLinks' | 'shopifyId'> {
  currentVariant: Variant;
  handleAddToCart: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => void;
}
export function AffiliateButtons({
  affiliatedLinks,
  shopifyId,
  currentVariant,
  handleAddToCart,
}: AffiliateButtonProps): JSX.Element {
  return (
    <ButtonsWrapper>
      {shopifyId && (
        <AffiliatedStyledButton
          variant="containedOutlined"
          isInternal={false}
          top={true}
          bottom={affiliatedLinks === null || affiliatedLinks?.length === 0}
          onClick={handleAddToCart}
          disabled={!currentVariant?.isAvailable}
        >
          {currentVariant?.isAvailable &&
            <>
              <AffiliateIcon src="/icons/ov_buy.svg" height={22} width={22} />
              Buy on OneVillage{' '}
              <Price>
                {getSymbolFromCurrency('usd')}
                {currentVariant?.price}
              </Price>
            </>
          }
          {!currentVariant?.isAvailable &&
            <>
              <AffiliateIcon src="/icons/ov_buy.svg" height={22} width={22} />

              Out of Stock
            </>
          }
        </AffiliatedStyledButton>
      )}
      {affiliatedLinks?.map(({ iconUrl, name, price, url }, index) => {
        return (
          <AffiliatedStyledButton
            key={name}
            variant="containedOutlined"
            top={index === 0 && !shopifyId}
            isInternal={
              index === 0 && shopifyId && index < affiliatedLinks.length
            }
            bottom={index === affiliatedLinks.length - 1}
            onClick={() => window.open(url, '_blank')}
          >
            <AffiliateIcon src={iconUrl} height={22} width={22} />
            {name}
            <Price>
              {getSymbolFromCurrency('usd')}
              {price}
            </Price>
          </AffiliatedStyledButton>
        );
      })}
    </ButtonsWrapper>
  );
}
